import React from 'react'
import styled from 'styled-components'
import { styles } from '../utils'
// import typography from '../utils'

export default function Banner({ title, subtitle, children }) {
  return (
    <BannerWrapper>
      <h1 className='title'>{title}</h1>
      <h3 className='subtitle'>{subtitle}</h3>
      {children}
    </BannerWrapper>
  )
}

const BannerWrapper = styled.div`
  margin-bottom: 3rem;
  text-align: center;
  .title {
    color: #fff;
    font-size: 2rem;
    font-weight: 500;
    text-transform: uppercase;
    ${styles.letterSpacing({ spacing: '0.2rem' })}
  }
  .subtitle {
    color: #fff;
    ${styles.letterSpacing({ spacing: '0.1rem' })};
    font-size: 1.2rem;
    text-transform: capitalize;
    font-weight: 400;
  }
`
Banner.defaultProps = {
  title: 'default title'
}
